import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05e8fa46")

_pushScopeId("data-v-05e8fa46")
const _hoisted_1 = { class: "toc_ui__ensure_main" }
const _hoisted_2 = {
  key: 0,
  class: "toc_ui__ensure_body"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "保障服务说明", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("享90天原价回购及终身补偿保障"),
  /*#__PURE__*/_createVNode("i")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "toc_ui__ensure_body"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", null, "服务说明", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("服务说明"),
  /*#__PURE__*/_createVNode("i")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.point === 'N' && !_ctx.state.reportMsg.RpFJ() && !_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", {
            class: "toc_ui__ensure_title",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toView && _ctx.toView(...args)))
          }, [
            _hoisted_4
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", {
            class: "toc_ui__ensure_title",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toView && _ctx.toView(...args)))
          }, [
            _hoisted_7
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})